import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.884 9.117h5.232a.884.884 0 010 1.767H3.884a.884.884 0 010-1.767h7z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
